import { render, staticRenderFns } from "./ProductionOrderImeiCell.vue?vue&type=template&id=673ec708"
import script from "./ProductionOrderImeiCell.vue?vue&type=script&lang=js"
export * from "./ProductionOrderImeiCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports